import React from "react";

// Evita la pantalla en blanco: si un componente falla al dibujarse, muestra un aviso
// con botón para recargar en lugar de cerrar toda la aplicación.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Error de pantalla:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" style={{ maxWidth: 480, margin: "15vh auto", padding: 24, fontFamily: "system-ui, sans-serif", textAlign: "center" }}>
        <h2 style={{ fontSize: 20, marginBottom: 8 }}>Algo salió mal al mostrar esta pantalla</h2>
        <p style={{ color: "#555", marginBottom: 16 }}>
          Tus datos están seguros. Recarga la página; si vuelve a pasar, avisa a Daniel Paiva e indica con qué navegador y si
          Chrome te ofreció traducir la página.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{ padding: "8px 18px", borderRadius: 6, border: 0, background: "#14532d", color: "#fff", cursor: "pointer" }}
        >
          Recargar
        </button>
      </div>
    );
  }
}
